module.exports = __webpack_public_path__ + "static/media/icon-pie-chart.65c907f9.svg";